import type { RouteRecordRaw } from 'vue-router';

export const analyticsRoutes: RouteRecordRaw[] = [
  {
    path: 'analytics/dashboard',
    name: 'analytics-dashboard',
    component: () => import('../pages/analytics/AnalyticsDashboardPage.vue'),
    meta: { requiresModule: 'analytics' },
  },
];
